import { render, staticRenderFns } from "./beneficiary.vue?vue&type=template&id=4c4928a4&"
import script from "./beneficiary.vue?vue&type=script&lang=js&"
export * from "./beneficiary.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCarousel,VCarouselItem,VDialog,VIcon})
